import { VIDEO_ADS_ENABLED } from "@scalephant/domain";
import { useGetCampaign } from "@scalephant/contract/client";
import { Link, Outlet, createFileRoute } from "@tanstack/react-router";

import { useT } from "../i18n/I18nProvider";

/**
 * One campaign, in tabs (IMPLEMENTATION_PLAN.md section 4): the overview where money is
 * changed by hand, the creatives, and the four the optimization package added. Each tab
 * is a route so it can be linked to and comes back after a reload.
 */
export const Route = createFileRoute("/app/campaigns/$campaignId")({
  component: CampaignLayout,
});

const active = { className: "font-semibold underline" };

function CampaignLayout() {
  const t = useT();
  const { campaignId } = Route.useParams();
  const detail = useGetCampaign(campaignId, { query: { retry: false } });
  const params = { campaignId };
  return (
    <>
      {detail.data ? <h1>{detail.data.campaign.name}</h1> : null}
      <nav
        className="my-4 flex flex-wrap gap-4 border-b pb-2 text-sm"
        aria-label={t("campaigns.title")}
      >
        <Link
          to="/app/campaigns/$campaignId"
          params={params}
          activeOptions={{ exact: true }}
          activeProps={active}
        >
          {t("campaigns.tab.overview")}
        </Link>
        <Link to="/app/campaigns/$campaignId/creatives" params={params} activeProps={active}>
          {t("campaigns.tab.creatives")}
        </Link>
        {VIDEO_ADS_ENABLED ? (
          <Link to="/app/campaigns/$campaignId/video" params={params} activeProps={active}>
            {t("campaigns.tab.video")}
          </Link>
        ) : null}
        <Link to="/app/campaigns/$campaignId/story" params={params} activeProps={active}>
          {t("campaigns.tab.story")}
        </Link>
        <Link to="/app/campaigns/$campaignId/intel" params={params} activeProps={active}>
          {t("campaigns.tab.intel")}
        </Link>
        <Link to="/app/campaigns/$campaignId/forecast" params={params} activeProps={active}>
          {t("campaigns.tab.forecast")}
        </Link>
        <Link to="/app/campaigns/$campaignId/policy" params={params} activeProps={active}>
          {t("campaigns.tab.policy")}
        </Link>
        <Link to="/app/campaigns/$campaignId/activity" params={params} activeProps={active}>
          {t("campaigns.tab.activity")}
        </Link>
      </nav>
      <Outlet />
    </>
  );
}
